import React, { useState } from "react"
import HubspotFormEmbed from "components/HubspotFormEmbed"
import { H4 } from "components/Typography"
import { BLOG_SUBSCRIPTION_FORM_ID } from "constants/hubspotFormIds"
import {
  BLOG_SUBSCRIPTION_FORM_TITLE,
  BLOG_SUBSCRIPTION_FORM_SUBTITLE,
} from "constants/texts"
import closeIcon from "./close.svg"
import * as css from "./FixedSubscriptionPopup.module.css"

function FixedSubscriptionPopup() {
  const [showPopup, setShowPopup] = useState(true)
  const [isSuccess, setIsSuccess] = useState(false)

  return showPopup ? (
    <div id="subscription-popup" className={css.container}>
      {isSuccess ? (
        <H4 className={css.thankYou}>Thank you!</H4>
      ) : (
        <>
          <div className={css.left}>
            <H4 className={css.heading}>{BLOG_SUBSCRIPTION_FORM_TITLE}</H4>
            <p>{BLOG_SUBSCRIPTION_FORM_SUBTITLE}</p>
          </div>
          <HubspotFormEmbed
            formId={BLOG_SUBSCRIPTION_FORM_ID}
            className={css.right}
            wrapperCssName={css.right}
            embedOptions={{
              submitButtonClass: css.button,
              errorMessageClass: css.errorMessage,
              translations: {
                en: {
                  submitText: "Subscribe",
                },
              },
            }}
            onSubmit={() => setIsSuccess(true)}
          />
        </>
      )}
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events */}
      <img
        className={css.close}
        src={closeIcon}
        alt="Close"
        onClick={() => setShowPopup(false)}
      />
    </div>
  ) : null
}

export default React.memo(FixedSubscriptionPopup)
